// src/auth/roleHome.js
/**
 * Where each role lands after login, and where ProtectedRoute sends a user
 * who opens a page their role can't use.
 */

const ROLE_HOME = {
    therapist: '/therapist',
    child: '/child',
    intake_worker: '/intake',
};

// Unknown roles go to /login rather than a protected page, which would
// redirect straight back and loop.
export default function roleHome(role) {
    return ROLE_HOME[role] || '/login';
}
